(function($) {


  $(document).ready(function() {
    $('[data-popup-id]').mouseenter(function() {
      var id = $(this).data('popup-id'),
          elemY = $(this).position().top,
          elemX = $(this).position().left,
          elemWith = $(this).width();

      $('#' + id)
      .css({
        bottom: elemY + 40,
        left: elemX + (elemWith / 2) - 85
      })
      .show();
    });

    $('[data-popup-id]').mouseleave(function() {
      var id = $(this).data('popup-id');
      $('#' + id).hide();
    });

  });

})(jQuery);
